import React from 'react';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
function VisaLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center min-w-[60px] h-10 shadow-sm" data-id="element-486">
      <span className="font-extrabold italic text-[#1A1F71] text-lg tracking-tight" data-id="element-487">
        VISA
      </span>
    </div>;
}
function MastercardLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center gap-0 min-w-[60px] h-10 shadow-sm" data-id="element-488">
      <span className="w-5 h-5 rounded-full bg-[#EB001B] -mr-1.5" data-id="element-489"></span>
      <span className="w-5 h-5 rounded-full bg-[#F79E1B] opacity-90 mix-blend-multiply" data-id="element-490"></span>
    </div>;
}
function AmexLogo() {
  return <div className="bg-[#006FCF] border border-[#006FCF] rounded-md px-3 py-2 flex items-center justify-center min-w-[60px] h-10 shadow-sm" data-id="element-491">
      <span className="font-extrabold text-white text-[10px] leading-tight text-center tracking-tight" data-id="element-492">
        AMERICAN
        <br data-id="element-493" />
        EXPRESS
      </span>
    </div>;
}
function PayPalLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center min-w-[60px] h-10 shadow-sm" data-id="element-494">
      <span className="font-extrabold italic text-lg leading-none" data-id="element-495">
        <span className="text-[#003087]" data-id="element-496">Pay</span>
        <span className="text-[#009CDE]" data-id="element-497">Pal</span>
      </span>
    </div>;
}
function ApplePayLogo() {
  return <div className="bg-black border border-black rounded-md px-3 py-2 flex items-center justify-center gap-1 min-w-[60px] h-10 shadow-sm" data-id="element-498">
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-white" aria-hidden="true" data-id="element-499">
        <path d="M17.5 12.5c0-2.5 2-3.7 2.1-3.8-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.6.9-.8 0-1.9-.9-3.1-.8-1.6 0-3.1.9-3.9 2.4-1.7 2.9-.4 7.2 1.2 9.6.8 1.2 1.7 2.5 3 2.4 1.2-.1 1.7-.8 3.1-.8s1.9.8 3.1.7c1.3 0 2.1-1.2 2.9-2.4.9-1.4 1.3-2.7 1.3-2.8-.1 0-2.6-1-2.6-3.5zM15.1 5.3c.7-.8 1.1-1.9 1-3-.9.1-2.1.6-2.7 1.4-.6.7-1.2 1.8-1 2.9 1 .1 2-.5 2.7-1.3z" data-id="element-500" />
      </svg>
      <span className="font-bold text-white text-xs" data-id="element-501">Pay</span>
    </div>;
}
function GooglePayLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center gap-1 min-w-[60px] h-10 shadow-sm" data-id="element-502">
      <span className="font-extrabold text-xs leading-none" data-id="element-503">
        <span className="text-[#4285F4]" data-id="element-504">G</span>
        <span className="text-[#EA4335]" data-id="element-505">o</span>
        <span className="text-[#FBBC04]" data-id="element-506">o</span>
        <span className="text-[#4285F4]" data-id="element-507">g</span>
        <span className="text-[#34A853]" data-id="element-508">l</span>
        <span className="text-[#EA4335]" data-id="element-509">e</span>
      </span>
      <span className="font-bold text-gray-700 text-xs" data-id="element-510">Pay</span>
    </div>;
}
export function TrustBadges() {
  const {
    t
  } = useLanguage();
  return <section className="w-full py-10 md:py-12 bg-[#FBF7F0] border-y border-[#3E2723]/10" data-id="element-511">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-512">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 text-center" data-id="element-513">
          <div className="flex flex-col items-center gap-2" data-id="element-514">
            <Lock className="w-7 h-7 text-[#14B8A6]" data-id="element-515" />
            <div className="text-sm font-bold text-[#3E2723]" data-id="element-516">
              {t('trustBadges.ssl')}
            </div>
            <div className="text-xs text-[#3E2723]/60" data-id="element-517">
              {t('trustBadges.sslDesc')}
            </div>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-518">
            <CreditCard className="w-7 h-7 text-[#14B8A6]" data-id="element-519" />
            <div className="text-sm font-bold text-[#3E2723]" data-id="element-520">
              {t('trustBadges.cards')}
            </div>
            <div className="text-xs text-[#3E2723]/60" data-id="element-521">
              {t('trustBadges.cardsDesc')}
            </div>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-522">
            <Zap className="w-7 h-7 text-[#14B8A6]" data-id="element-523" />
            <div className="text-sm font-bold text-[#3E2723]" data-id="element-524">
              {t('trustBadges.access')}
            </div>
            <div className="text-xs text-[#3E2723]/60" data-id="element-525">
              {t('trustBadges.accessDesc')}
            </div>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-526">
            <ShieldCheck className="w-7 h-7 text-[#14B8A6]" data-id="element-527" />
            <div className="text-sm font-bold text-[#3E2723]" data-id="element-528">
              {t('trustBadges.guarantee')}
            </div>
            <div className="text-xs text-[#3E2723]/60" data-id="element-529">
              {t('trustBadges.guaranteeDesc')}
            </div>
          </div>
        </div>

        <div className="border-t border-[#3E2723]/10 mt-8 pt-8" data-id="element-530">
          <div className="text-xs uppercase tracking-[0.25em] text-[#3E2723]/60 font-bold text-center mb-5" data-id="element-531">
            {t('trustBadges.accept')}
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4" data-id="element-532">
            <VisaLogo data-id="element-533" />
            <MastercardLogo data-id="element-534" />
            <AmexLogo data-id="element-535" />
            <PayPalLogo data-id="element-536" />
            <ApplePayLogo data-id="element-537" />
            <GooglePayLogo data-id="element-538" />
          </div>
        </div>
      </div>
    </section>;
}